document.addEventListener("DOMContentLoaded", () => {

    let recentDealsSwipers = document.getElementsByClassName('recent-deals-swiper');

    for (let i = 0; i < recentDealsSwipers.length; i++) {

        let swiperElement = recentDealsSwipers[i];

        let elementID = swiperElement.dataset.elementid;
        let swiperID = '#' + swiperElement.id;

        let nextElButtonClass = '.recent-deals-next-' + elementID;
        let prevElButtonClass = '.recent-deals-prev-' + elementID;

        const swiper = new Swiper(swiperID, {
            direction: 'horizontal',
            loop: true,
            slidesPerView: 1.2,
            spaceBetween: 20,
            navigation: {
                nextEl: nextElButtonClass,
                prevEl: prevElButtonClass,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.5,
                },
                992: {
                    slidesPerView: 1.5,
                },
                1200: {
                    slidesPerView: 2.5,
                },
                1440: {
                    slidesPerView: 2.5,
                }
            }
        });

    }
});
